import { FloatingFormItem } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  FinancialBillsToReceiveFormValues,
  OrderBy,
  ReportType,
  FilterByDate,
} from '@/core/domain/reports/financial/billsToReceive/billsToReceive.types';
import {
  Checkbox,
  Col,
  Divider,
  Form,
  FormInstance,
  Radio,
  Row,
  Select,
  Typography,
} from 'antd';
import { useIntl } from 'react-intl';

import BillsToReceiveMoreOptions from './BillsToReceiveMoreOptions';
import BillsToReceiveRadios from './BillsToReceiveRadios';

interface Props {
  form: FormInstance<FinancialBillsToReceiveFormValues>;
}
const { Title } = Typography;

const FinancialBillsToReceiveForm: React.FC<Props> = ({ form }) => {
  const intl = useIntl();

  const reportType = Form.useWatch('reportType', form);
  const analitic = Form.useWatch('analitic', form);

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <>
            <Title level={5}>
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.filterByDate',
              })}
            </Title>

            <Form.Item
              noStyle
              name="dateType"
              initialValue={FilterByDate.maturity}
            >
              <Radio.Group optionType="button" buttonStyle="solid" size="large">
                <Radio value={FilterByDate.issue}>
                  {intl.formatMessage({
                    id: 'financial.billsToReceive.form.filterByDate.issue',
                  })}
                </Radio>
                <Radio value={FilterByDate.maturity}>
                  {intl.formatMessage({
                    id: 'financial.billsToReceive.form.filterByDate.maturity',
                  })}
                </Radio>
                <Radio value={FilterByDate.receipt}>
                  {intl.formatMessage({
                    id: 'financial.billsToReceive.form.filterByDate.receipt',
                  })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </>
        }
      />

      <Row>
        <Col xs={24}>
          <BillsToReceiveRadios />
        </Col>

        <Col span={24}>
          <FloatingFormItem valuePropName="checked" name="analitic">
            <Checkbox
              onClick={() => form.setFieldValue('synthetic', undefined)}
            >
              {intl.formatMessage({
                id: 'financial.billsToReceive.form.analitic',
              })}
            </Checkbox>
          </FloatingFormItem>
        </Col>

        {reportType === ReportType.chartOfAccounts && (
          <Col span={24}>
            <FloatingFormItem valuePropName="checked" name="synthetic">
              <Checkbox
                onClick={() => form.setFieldValue('analitic', undefined)}
              >
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.synthetic',
                })}
              </Checkbox>
            </FloatingFormItem>
          </Col>
        )}

        {!analitic && (
          <Col span={24}>
            <FloatingFormItem valuePropName="checked" name="landingPage">
              <Checkbox>Exibido na horizontal</Checkbox>
            </FloatingFormItem>
          </Col>
        )}

        <Col span={24}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'financial.billsToReceive.form.orderBy',
            })}
            name="reportSortType"
            initialValue={OrderBy.debtor}
          >
            <Select>
              <Select.Option value={OrderBy.date}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.date',
                })}
              </Select.Option>
              <Select.Option value={OrderBy.description}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.description',
                })}
              </Select.Option>
              <Select.Option value={OrderBy.debtor}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.debtor',
                })}
              </Select.Option>
              <Select.Option value={OrderBy.code}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.code',
                })}
              </Select.Option>
              <Select.Option value={OrderBy.planAccount}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.planAccount',
                })}
              </Select.Option>
              <Select.Option value={OrderBy.documentType}>
                {intl.formatMessage({
                  id: 'financial.billsToReceive.form.orderBy.documentType',
                })}
              </Select.Option>
            </Select>
          </FloatingFormItem>
        </Col>

        <Divider />

        <Col xs={24}>
          <BillsToReceiveMoreOptions form={form} />
        </Col>
      </Row>
    </Form>
  );
};

export default FinancialBillsToReceiveForm;
